import React, { useEffect, useState } from "react";
import { Stack, IStackItemStyles, IStackStyles} from "@fluentui/react/lib/Stack";
import { IIconStyles, Spinner, Text} from "@fluentui/react";
import { useHistory } from "react-router-dom";
import { IAttributes, IUCISModel } from "../../Interfaces/interface";
import { logUCMetrics } from "../InterruptPage/UCMetricsLogger";
import useMediaQuery from "../../Utilities/useHooks";
import { TABLET, MOBILE, DESKTOP, SMALL_HEIGHT_FOR_TABLET_AND_DESKTOP, SMALL_HEIGHT } from "../../Utilities/mediaTypes";
import { IconButton } from "@fluentui/react/lib/Button";
import { isAndroid } from "../../Utilities/common";

// tslint:disable-next-line: max-func-body-length
export const LearnMore: React.FC = () => {

    const TIMEOUT = 30000;
    let timeoutId: number;
    const ucisData: IUCISModel = window.ucis;
    const ucisModelTexts: IAttributes = ucisData?.ModelSchema?.modelTexts[0].attributes;
    const learnMoreURL = ucisModelTexts["learnMore-linkUrl"];

    const history = useHistory();

    let isTablet = useMediaQuery(TABLET);
    let isMobile = useMediaQuery(MOBILE);
    let isDesktop = useMediaQuery(DESKTOP);
    let isSmallHeightForTabletAndDesktop = useMediaQuery(SMALL_HEIGHT_FOR_TABLET_AND_DESKTOP);
    let isSmallHeight = useMediaQuery(SMALL_HEIGHT);
    let isMobileAndroid = isAndroid() && isMobile;

    const learnMoreURLWithLang: URL = new URL(learnMoreURL);

    learnMoreURLWithLang.searchParams.append("lang", ucisData?.ModelSchema?.languageCode);

    const [loading, setLoading] = useState<boolean>(true);

    const buttonStackStyle = (): IStackStyles => ({
        root: {
            marginInlineStart: "-8px"
        }
    });

    const flexboxStackStyles = (): IStackStyles => ({
        root: {
            direction: "ltr",
            display: "flex",
            flexDirection: "row"
        }
    });

    const spinnerStackStyle: IStackStyles = {
        root: {
            alignItems: "center",
            display: "flex",
            height: isSmallHeight ? "calc(100vh - 100px)" : "586px",
            justifyContent: "center"
        },
    };

    const getDialogBodyStyles: IStackStyles = {
        root: {
            backgroundColor: "#ffffff",
            boxShadow: "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2);",
            height: (isDesktop && !isSmallHeightForTabletAndDesktop) ? "724px" : "100%",
            minWidth: (isMobile || isTablet || isSmallHeightForTabletAndDesktop) ? "100%" : "auto",
            position: (isMobileAndroid) ? "fixed" : "relative",
            width: isMobile ? "auto" : "440px"
        },
    };

    const innerStackStyles: IStackStyles = {
        root: {
            height: "24px",
            marginBottom: "0px",
            marginLeft: isMobile ? "24px" : (isTablet || isSmallHeightForTabletAndDesktop) ? "calc((100vw - 352px - 17px) / 2)" : "44px",   // 17px is added to accomodate width of scroll bar
            marginRight: isMobile ? "24px" : (isTablet || isSmallHeightForTabletAndDesktop) ? "calc((100vw - 352px - 17px) / 2 )" : "44px",
            marginTop: isMobile ? "24px" : "44px",
            position: "relative",
            width: "auto",
        },
    };

    const iconStyle: IIconStyles = {

        root: {
            color: "#212121",
            height: "24px",
            width: "24px"
        }
    };

    const stackItemStylesIframe: IStackItemStyles = {
        root: {
            height: "100%",
            marginBottom: isMobile ? "24px" : "44px",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "4px !important",
            width: (isTablet || isSmallHeightForTabletAndDesktop) ? "417px" : "100%"   //(369 + 24 + 24) to accomodate the 24px margin of learn more page inside iframe.
        },
    };

    useEffect(() => {
        logUCMetrics("ConsentLearnMore", ucisData);
        timeoutId = window.setTimeout(() => {
            setLoading(false);
        }, TIMEOUT);
    }, []);

    const onButtonClick = () => {
        history.push("/");
    };

    const onLoaded = () => {
        setLoading(false);
        window.clearTimeout(timeoutId);
    };

    const HeaderFlexBox = () => {
        return (
            <Stack styles={flexboxStackStyles}>
                <Stack styles= {buttonStackStyle} >
                    <IconButton
                        iconProps={{ iconName: "ChevronLeft" }}
                        styles={iconStyle}
                        onClick={onButtonClick}
                        data-testid="back"
                        aria-label={ucisModelTexts["learnMore-backButton"]}
                    />
                </Stack>
            </Stack>
        );
    };

    const loaderTextStyle = (): IStackStyles => {
        return {
            root: {
                color: "#0078D4",
                fontSize: "12px",
                fontStyle: isMobile ? "Roboto" : "Segoe UI",
                fontWeight: "400",
                lineHeight: "16px",
            }
        };
    };



    const LoadingSpinner = () => {
        return (
            <Stack styles={spinnerStackStyle}>
            <Spinner
                className="loading text-center"
                color="white"
                size={3}
                />
                <Text styles={loaderTextStyle}>{ucisModelTexts["general-pleaseWait"]}</Text>
            </Stack>
        );
    };

    const iframeStyle = {
            display: loading ? "none" : "block"
    };

    return (
        <>
            <Stack styles={getDialogBodyStyles} id="learnMoreDialog">
                <Stack styles={innerStackStyles} id="stackContainer">
                    <HeaderFlexBox/>
                </Stack>
                <Stack styles={stackItemStylesIframe}>
                    {loading ? <LoadingSpinner/> : null}
                    <iframe src={learnMoreURLWithLang.href} sandbox="allow-scripts" height="100%" width="100%" frameBorder="0" onLoad={onLoaded} style={iframeStyle} role="presentation"></iframe>
                </Stack>
            </Stack>
        </>
    );
};
